export const preProcessingDataColumns = [
  {
    display_name: "",
    key: "select",
    headerStyles: {
      background: "#7593F2",
      color: "#ffffff",
      padding: "4px 8px",
      width: "50px",
    },
    cellStyles: {
      width: "50px",
    },
    _config: {
      type: "checkbox",
      displayInColumn: true,
      value: "id",
      isClickable: "true",
    },
  },
  {
    display_name: "#",
    headerStyles: {
      width: "10%",
    },
    key: "serial_number",
  },
  {
    display_name: "File Name",
    key: "filename",
  },
  {
    display_name: "Type",
    key: "type",
  },
  {
    display_name: "Size",
    key: "size",
  },
  {
    display_name: "Updated Date",
    key: "date",
  },
  {
    display_name: "Execution Release",
    key: "release",
    headerStyles: {
      background: "#7593F2",
      padding: "4px 8px",
      width:"30%"
    },
    _config: {
      type: "multi-select",
      isMulti:true,
      value: "",
      placeholder: "Select Releases",
      options: [
        {
          label: "Release01",
          value: "Release01",
        },
        {
          label: "Release02",
          value: "Release02",
        }, {
          label: "Release03",
          value: "Release03",
        },
        {
          label: "Release04",
          value: "Release04",
        },
        {
          label: "Release05",
          value: "Release05",
        }
      ],
    },
  }
];
